import { render, staticRenderFns } from "./FeatureForm.vue?vue&type=template&id=c96d7442&scoped=true&"
import script from "./FeatureForm.vue?vue&type=script&lang=js&"
export * from "./FeatureForm.vue?vue&type=script&lang=js&"
import style0 from "./FeatureForm.scss?vue&type=style&index=0&id=c96d7442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d7442",
  null
  
)

export default component.exports